import { Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FgjsService, ILivingComplex, ILivingComplexUser, IUserObjectData } from '../../users-fgjs/fgjs.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-add-objects',
  templateUrl: './add-objects.component.html',
  styleUrl: './add-objects.component.scss'
})
export class AddObjectsComponent {
  buildings: ILivingComplex[] = [];
  displayedColumns = ['checkBox', 'complexId', 'complexName'];
  complexes: MatTableDataSource<ILivingComplex>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() complexesSelected = new EventEmitter<ILivingComplex[]>();

  selectedComplexes: ILivingComplex[] = [];
  selectComp: ILivingComplexUser[] = [];

  totalItems: number = 0;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 20];

  searchTerm: string;
  isSearchMode: boolean = false;

  initialSelectedComplexes: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddObjectsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IUserObjectData,
    private snackBar: MatSnackBar,
    private paginatorRus: MatPaginatorIntl,
    private service: FgjsService
  ){
    paginatorRus.itemsPerPageLabel = 'Количество объектов на странице';
    paginatorRus.nextPageLabel = 'Следующая страница';
    paginatorRus.previousPageLabel = 'Предыдущая страница';
    paginatorRus.lastPageLabel = 'Последняя страница';
    paginatorRus.firstPageLabel = 'Первая страница';
  }

  ngOnInit(){
    this.loadLivingComplexes();
    this.loadSelection(this.data.id);
  }

  loadLivingComplexes(event?: PageEvent) {
    const pageNumber = event ? event.pageIndex + 1 : 1;
    const pageSize = event ? event.pageSize : this.pageSize;
    let selectionLv = [];
    this.service.getLivingComplexesPaginated(pageNumber, pageSize)
    .subscribe(
      (response: any) => {
          selectionLv = this.data.anchoredLvComplex.reduce((acc, cur) => {
            if (!(!!this.selectComp.find(el => el.livingComplexID == cur.livingComplexID))) acc.push(cur);
            return acc;
          }, []);
          this.buildings = response.objects.map(r => {
            return {
              id: r.id,
              name: r.name,
              isCompleted: r.isCompleted,
              disabled: !!selectionLv.find(el => el.livingComplexID == r.id)
            }
          });
          this.totalItems = response.infoByRegion[0].totalcnt;
          //this.loadTable();
          this.showSelectedObjects();
        }
      );
  }

  loadTable(){
    this.complexes = new MatTableDataSource(this.buildings.filter(f => f.isCompleted === false));
  }

  search(event?: PageEvent) {
    this.isSearchMode = true;
    const pageNumber = event ? event.pageIndex + 1 : this.paginator.pageIndex + 1;
    const pageSize = event ? event.pageSize : this.paginator.pageSize;

    if (this.searchTerm) {
      const isId = !isNaN(Number(this.searchTerm));

      if (isId) {
        this.searchById(Number(this.searchTerm), pageNumber, pageSize);
      } else {
        this.searchByTitle(this.searchTerm, pageNumber, pageSize);
      }
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.complexes.filter = filterValue.trim().toLowerCase();

    if (this.complexes.paginator) {
      this.complexes.paginator.firstPage();
    }
  }

  private searchById(id: number, pageNumber: number, pageSize: number) {
    this.service.searchLivingComplexesById(id, pageNumber, pageSize).subscribe(
      (res: any) => this.handleSearchResult(res)
    );
  }

  private searchByTitle(title: string, pageNumber: number, pageSize: number) {
    this.service.searchLivingComplexesByTitle(title, pageNumber, pageSize).subscribe(
      (res: any) => this.handleSearchResult(res)
    );
  }

  private handleSearchResult(res: any) {
    this.buildings = res.objects.map(r => ({
      id: r.id,
      name: r.name,
      isCompleted: r.isCompleted
    }));
    this.totalItems = res.objects.length;
    this.loadTable();
  }

  loadSelection(id) {
    this.service.getComplexUser(id).subscribe((res: any) => {
      this.selectComp = res;
      this.initialSelectedComplexes = res.map(item => item.livingComplexID);
      this.selectedComplexes = res.map(item => ({
        id: item.livingComplexID,
        name: item.livingComplexTitle,
        isCompleted: false
      }));
    })
  }

  onComplexSelected(event: MatCheckboxChange, complex: ILivingComplex) {
    if (event.checked) {
      if (!this.selectedComplexes.some(c => c.id === complex.id)) {
        this.selectedComplexes.push(complex);
      }
    } else {
      this.selectedComplexes = this.selectedComplexes.filter(c => c.id !== complex.id);
    }
  }

  showSelectedObjects() {
    if (this.selectComp.length) {
      const selectedEntries = this.selectComp.map(r => ({
        id: r.livingComplexID,
        name: r.livingComplexTitle,
        isCompleted: this.buildings.some(b => b.id === r.livingComplexID)
      }));
      const newEntries = selectedEntries.filter(entry =>
        !this.buildings.some(b => b.id === entry.id)
      );
      this.buildings.unshift(...newEntries);
      this.loadTable();
    } else {
      this.loadTable();
    }
  }

  isComplexSelected(element: any): boolean {
    return this.selectComp.some(item => item.livingComplexID === element.id);
  }

  okClick() {
    if (this.selectedComplexes) {
      const complexesToDelete = this.initialSelectedComplexes.filter(
        id => !this.selectedComplexes.some(complex => complex.id === id)
      );
      const deletionPromises = complexesToDelete.map(id =>
        this.service.deleteComplex(this.data.id, id)
      );


      Promise.all(deletionPromises)
        .then(() => {
          this.complexesSelected.emit(this.selectedComplexes);
          this.snackBar.open('Объекты успешно обновлены!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          this.dialogRef.close();
        })
        .catch(error => {
          this.snackBar.open('Произошла ошибка!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-error']
          });
        });
      } else {
        this.snackBar.open('Вы не выбрали объект!', '', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'right',
          panelClass: ['snackbar-error']
        });
      }
  }
}
